import { useContext } from 'react'

import ReferralLandingPageRepository from './referral-landing-page.repository'
import { ActionTypes } from '../../stores/App/AppReducer'
import { AppContext } from '../../stores/App/AppStore'

const useReferralLandingPageRepository = () => {
    const { dispatch } = useContext(AppContext)
    const referralLandingPageRepository = new ReferralLandingPageRepository()

    const setReferralCode = (membershipPlan?: string) => {
        referralLandingPageRepository.setReferralCode(membershipPlan)
    }

    const getReferralCode = (): string | undefined => {
        return referralLandingPageRepository.getReferralCode()
    }

    const getReferralPage = () => {
        referralLandingPageRepository.retrieveReferralLandingPage()
            .then(referralLandingPageData => {
                dispatch({ type: ActionTypes.REFERRAL_LANDING_PAGE_RETRIEVED, referralLandingPageData })
            })
            .catch(error => {
                console.error(error.message)
            })
    }

    const getReferreeDetails = async (ids: string[]) => {
        const refereeDetails = await referralLandingPageRepository.getReferreeDetails(ids)
        return refereeDetails
    }

    const resetReferralCode = () => {
        referralLandingPageRepository.setReferralCode()
    }

    return {
        setReferralCode,
        getReferralCode,
        getReferralPage,
        resetReferralCode,
        getReferreeDetails,
    }
}

export { useReferralLandingPageRepository }